import { gql } from '@apollo/client'

/**
 * Paid revenue for the dashboard weekly chart.
 * Uses the same registrationPayments surface as account transaction history:
 * online charges and off-platform / marked-as-paid entries with transactions.
 *
 * TODO(backend): optional pgaCoachAnalytics.earnings.byWeek if weekly buckets
 * should come from analytics instead of client-side payment aggregation.
 */
export const GET_GROWTH_REGISTRATION_PAYMENTS = gql`
  query GetGrowthRegistrationPayments($createdAt: DateTimeRangeInput) {
    registrationPayments(createdAt: $createdAt) {
      id
      createdAt
      totalInCents
      leftToRefundInCents
      transactions {
        amountInCents
        refund
        sourceType
        createdAt
      }
    }
  }
`

/**
 * Current-month schedule for booking mix (Private / Group / Packages).
 */
export const GET_GROWTH_BOOKING_MIX_SCHEDULE = gql`
  query GetGrowthBookingMixSchedule(
    $startDateTime: DateTimeRangeInput!
    $orderBy: [ScheduleOrderByInput!]!
  ) {
    currentUser {
      schedule(startDateTime: $startDateTime, orderBy: $orderBy) {
        __typename
        id
        isCanceled
        enrollments {
          lessonCredit {
            lessonPack {
              id
            }
          }
        }
      }
    }
  }
`
